import { callSaradiumBackend } from "../../lib/appwrite";
import {
  fromCloudCountdown,
  toCloudCountdown,
} from "./countdown.mapper";
import type { Countdown } from "./countdown.types";

type ListResponse = {
  rows?: Array<Record<string, unknown>>;
};

type RowResponse = {
  row?: Record<string, unknown>;
  $id?: string;
};

export async function getCloudCountdowns(): Promise<
  Countdown[]
> {
  const response = await callSaradiumBackend<ListResponse>({
    action: "listMyRows",
    table: "countdowns",
    cursor: "",
  });

  return (response.rows || [])
    .map((row) =>
      fromCloudCountdown(
        row as Parameters<
          typeof fromCloudCountdown
        >[0],
      ),
    )
    .filter(
      (countdown) =>
        new Date(countdown.eventAt).getTime() > 0,
    )
    .sort(
      (first, second) =>
        new Date(first.eventAt).getTime() -
        new Date(second.eventAt).getTime(),
    );
}

export async function createCloudCountdown(
  countdown: Countdown,
): Promise<Countdown> {
  const response = await callSaradiumBackend<RowResponse>({
    action: "createMyRow",
    table: "countdowns",
    data: toCloudCountdown(countdown),
  });

  const row = response.row || response;

  if (!row.$id) {
    throw new Error(
      "The countdown was saved but no cloud row was returned.",
    );
  }

  return fromCloudCountdown(
    row as Parameters<typeof fromCloudCountdown>[0],
  );
}

export async function updateCloudCountdown(
  countdown: Countdown,
): Promise<Countdown> {
  if (!countdown.cloudId) {
    return createCloudCountdown(countdown);
  }

  const response = await callSaradiumBackend<RowResponse>({
    action: "updateMyRow",
    table: "countdowns",
    rowId: countdown.cloudId,
    data: toCloudCountdown(countdown),
  });

  const row = response.row || response;

  return row.$id
    ? fromCloudCountdown(
        row as Parameters<
          typeof fromCloudCountdown
        >[0],
      )
    : countdown;
}

export async function deleteCloudCountdown(
  countdown: Countdown,
): Promise<void> {
  if (!countdown.cloudId) {
    return;
  }

  await callSaradiumBackend({
    action: "deleteMyRow",
    table: "countdowns",
    rowId: countdown.cloudId,
  });
}